import { useCallback } from "react";

export const useGetFormData = (parentId: string | undefined) => {
  const getFormData = useCallback(
    (entry: any, id: string | null): any => {
      const request: any = {
        ...entry,
        date: entry.date.format(),
      };

      if (entry.file && entry.file.length > 0) {
        request.fileId = entry.file[0].response;

        delete request.file;
      } else if (id) {
        request.deleteFile = true;
      }

      if (parentId) {
        request.contractId = parentId;
      }

      return request;
    },
    [parentId]
  );

  return { getFormData };
};
